import React, {useCallback} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Grid} from '@material-ui/core';

import {
    CategoryRequest,
    CategoryList,
} from './components';
import {getAllCategory, sendCategoryAuth} from '../../apis/api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const Error = () => (<div>Error</div>);

const Request = () => {
    const classes = useStyles();
    const MESSAGE = {
        ERROR_CATEGORY: 'Please select a category',
        SUCCESS_AUTH: 'The permission request was successful.',
        ERROR_AUTH: 'Permission request failed.',
    };

    // 카테고리 선택
    const [category, setCategory] = React.useState({});
    const changeCategory = (cate = {}) => {
        setCategory(cate);
    };

    // 대카테고리 리스트 가져오기
    const [categoryList, setCategoryList] = React.useState([]);
    if (categoryList.length === 0) {
        getAllCategory()
            .then((res) => {
                if (res.statusCode === 0) return errorHandler();

                setCategoryList(res);
            }).catch(() => {
                return errorHandler();
            });
    }

    const errorHandler = () => <Error />;

    const errorSendAuth = useCallback(() => {
        alert(MESSAGE.ERROR_AUTH);
    }, [MESSAGE]);

    const [refresh, setRefresh] = React.useState(false);

    const onSubmit = () => {
        const {parentCode: category1, code: category2} = category;

        if (category1 && category2) {
            sendCategoryAuth(category.code)
                .then((res) => {
                    if (res.result) {
                        alert(MESSAGE.SUCCESS_AUTH);
                        setRefresh(true);
                        return;
                    }

                    return errorSendAuth();
                }).catch(() => {
                    return errorSendAuth();
                }).finally(() => {
                    setRefresh(false);
                });
        } else {
            alert(MESSAGE.ERROR_CATEGORY);
        }
    };

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <CategoryRequest
                        categoryList={categoryList}
                        changeCategory={changeCategory}
                        onSubmit={onSubmit}
                    />
                </Grid>

                <Grid
                    item
                    lg={12}
                    md={12}
                    xl={12}
                    xs={12}
                >
                    <CategoryList refresh={refresh}/>
                </Grid>
            </Grid>
        </div>
    );
};

export default Request;
